import {empty} from "../Core/common";
import {modal} from "../UI/modal";
import {notice} from "../UI/notice";
import config from "../../Config/config";

export const addToCart = (events, evt) =>{
    let self = evt.currentTarget || evt.target;

    evt.preventDefault();
    evt.stopPropagation();

    let form = self.closest('.js_item');
    let countComponent = form.querySelector('.count_product_item');

    let cnt = 1;
    if(countComponent){
        cnt = countComponent.value;
    }

    let productId = self.dataset.id;
    let chose = self.dataset.chose || 0;

    if (empty(cnt)) {
        cnt = 1;
    }

    const dataJson = {};

    form.querySelectorAll('[data-choise="true"]:checked').forEach(item => {
        dataJson[item.getAttribute('name')] = item.value;
    });

    let output = {
        action: 'addtocart',
        product_id: productId,
        chose: chose,
        data_json: dataJson,
        count: cnt,
    };

    (async () => {
        try {
            self.classList.add('preloader');
            const rawResponse = await fetch(`/includes/modules/cart/cart_functions.php`, {
                mode: 'cors',
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: 'data=' + JSON.stringify(output)
            });
            const content = await rawResponse.json();

            if (content.success) {
                if (['/cart.html', '/basket.html'].includes(document.location.pathname)) {
                    document.location.reload();
                    return;
                }
              //  self.classList.add('active');

                events.dispatch(config.listeners.basket.added, content);

                notice('Товар добавлен в корзину.');
            } else {
                modal({
                    'message' : "Ошибка. Обратитесь к администратору.",
                    'closeBtm': `<button 
                                                type="button" 
                                                style="z-index: 1;"
                                                class="btn-close position-absolute border-0 ms-auto d-flex p-10 bg-main product-item-sale top-0 end-0" 
                                                data-bs-dismiss="modal" 
                                                aria-label="Close"
                                            >
                                            <i class="u_multiply icon fs-20 text-white"></i>
                                        </button>`,
                }, function (el, modal) {
                    setTimeout(modal.hide, 2000);
                });
            }
        } catch (e) {
            modal({
                'message' :  e.message || '<h3>Не удалось выполнить действие</h3>',
                'closeBtm': `<button 
                                                type="button" 
                                                style="z-index: 1;"
                                                class="btn-close position-absolute border-0 ms-auto d-flex p-10 bg-main product-item-sale top-0 end-0" 
                                                data-bs-dismiss="modal" 
                                                aria-label="Close"
                                            >
                                            <i class="u_multiply icon fs-20 text-white"></i>
                                        </button>`,
            }, function (el, modal) {
                setTimeout(modal.hide, 2000);
            });
        } finally {
            self.classList.remove('preloader');
        }
    })();
};
